"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = accessProperty;
function accessProperty(object, accessor) {
  return typeof accessor === 'function' ? accessor(object) : object[accessor];
}
//# sourceMappingURL=accessProperty.js.map